import { RefObject } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslations } from 'next-intl'
import {
  FormControl,
  InputGroup,
  Input,
  InputRightElement,
  Button,
  FormErrorMessage,
  useToast,
  useColorModeValue,
} from '@chakra-ui/react'
import { useRouter } from 'next/router'

import { EXTERNAL_SUBSCRIBE_FORM } from '@/constants'
import { RightLongArrowIcon } from '@/components/icons/RightLongArrowIcon'
import { ISubscribeFormValues } from '@/types/subscribeForm.interface'
import { EMAIL_PATTERN } from '@/utils/inputPattern'

type Props = {
  formRef: RefObject<HTMLDivElement>
}

export const NewsletterForm = ({ formRef }: Props) => {
  const t = useTranslations()
  const toast = useToast()

  const {
    handleSubmit,
    reset,
    register,
    getValues,
    formState: { errors },
  } = useForm<ISubscribeFormValues>({ defaultValues: { newsletterEmail: '' } })

  const handleSubscribe = () => {
    const { newsletterEmail } = getValues()
    const url = `${EXTERNAL_SUBSCRIBE_FORM}?email=${newsletterEmail}`
    if (window) {
      window.open(url, '_blank')
    }
  }

  return (
    <FormControl
      ref={formRef}
      id="subscribeFormControl"
      isInvalid={!!errors?.newsletterEmail}
    >
      <InputGroup size="lg">
        <Input
          id="newsletterEmail"
          placeholder={t('auth.form.enter-email')}
          fontSize="14px"
          type="email"
          rounded="xl"
          borderColor={'gray.930'}
          borderWidth="1px"
          pr="200px"
          _placeholder={{ color: 'gray.550' }}
          {...register('newsletterEmail', {
            required: t('forms.errors.is-required'),
            pattern: {
              value: EMAIL_PATTERN,
              message: t('forms.errors.valid-email'),
            },
          })}
        />
        <InputRightElement width="192px" mr={0}>
          <Button
            w="full"
            size={'lg'}
            fontWeight={700}
            fontSize={'14px'}
            background={useColorModeValue('black', 'white')}
            color={useColorModeValue('white', 'black')}
            onClick={handleSubmit(handleSubscribe)}
            rounded={'2xl'}
            loadingText={t('buttons.subscribe')}
            _hover={{
              background: useColorModeValue('blackAlpha.700', 'whiteAlpha.700'),
            }}
          >
            {t('buttons.subscribe')}
            <RightLongArrowIcon w={'30px'} h={'20px'} ml={10} />
          </Button>
        </InputRightElement>
      </InputGroup>
      <FormErrorMessage>{errors.newsletterEmail?.message}</FormErrorMessage>
    </FormControl>
  )
}
